export const CONVERT_IBC_TO_OSMO_VALUE = "0471F1C4E7AFD3F07702BEF6DC365268D64570F7C1FDC98EA6098DD6DE59817B";

export const IBC_SUPPORT_CHAIN = [
    {
        chainId: "colosseum-1",
        channelId: "channel-1",
        denom: "ufct",
        icon: "/images/ic_firmachain_40px.png",
        name: "FIRMACHAIN",
        ticker: "FCT"
    },
    {
        chainId: "osmosis-1",
        channelId: "channel-79241",
        denom: "uosmo",
        icon: "/images/ic_osmosis_logo2.png",
        name: "OSMOSIS",
        ticker: "OSMO"
    },
    {
        chainId: "cosmoshub-4",
        channelId: "",
        denom: "uatom",
        icon: "/images/ic_cosmos_logo.png",
        name: "COSMOS",
        ticker: "ATOM"
    }
]